module.exports = __webpack_public_path__ + "static/assets/69356611b88705ba55f6680a2010f539.png";